import LineLoader from '@ubnt/ui-components/LineLoader/LineLoader';
import { tunnels } from 'modules/editor/tunnels';

export function Loader() {
  return (
    <tunnels.overlay.In>
      <LineLoader isLoading />
    </tunnels.overlay.In>
  );
}
